import { useMutation } from "@apollo/client";
import { toast } from "react-toastify";
import { evictFields } from "../../../helpers/cache";
import {
  MARK_NOTIFICATIONS_AS_READ,
  MARK_ALL_NOTIFICATIONS_AS_READ,
} from "../notification.queries";
import {
  MarkNotificationsAsReadMutation,
  MarkNotificationsAsReadMutationVariables,
} from "../../../__generated__/MarkNotificationsAsReadMutation";
import { MarkAllNotificationsAsReadMutation } from "../../../__generated__/MarkAllNotificationsAsReadMutation";

export const useMarkNotificationsAsRead = () => {
  const [markSome, { loading: markingSome }] = useMutation<
    MarkNotificationsAsReadMutation,
    MarkNotificationsAsReadMutationVariables
  >(MARK_NOTIFICATIONS_AS_READ, {
    refetchQueries: ["MyNotificationsQuery"],
    update(cache) {
      evictFields(cache, ["myNotifications", "notification"]);
    },
  });

  const [markAll, { loading: markingAll }] = useMutation<MarkAllNotificationsAsReadMutation>(
    MARK_ALL_NOTIFICATIONS_AS_READ,
    {
      refetchQueries: ["MyNotificationsQuery"],
      update(cache) {
        evictFields(cache, ["myNotifications", "notification"]);
      },
    }
  );

  const loading = markingSome || markingAll;

  const markAsRead = async (ids: number[]) => {
    if (!ids.length) return;
    try {
      await markSome({ variables: { ids } });
    } catch (error: any) {
      toast.error(error?.message ?? "Une erreur est survenue");
    }
  };

  const markAllAsRead = async () => {
    if (loading) return;
    try {
      const { data } = await markAll();
      if (data?.markAllNotificationsAsRead?.ok) {
        toast.success("Toutes les notifications ont été marquées comme lues");
      } else {
        toast.error(
          data?.markAllNotificationsAsRead?.error ?? "Une erreur est survenue"
        );
      }
    } catch (error: any) {
      toast.error(error?.message ?? "Une erreur est survenue");
    }
  };

  return { markAsRead, markAllAsRead, loading };
};
